import script from "./img-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./img-upload.vue?vue&type=script&setup=true&lang=js"

import "./img-upload.vue?vue&type=style&index=0&id=f12cb808&lang=scss"

const __exports__ = script;

export default __exports__